export const extensionOnlyAllowlistAxa = ['eml', 'msg'];
